import { createIcon } from '../createIcon';
import { ReactComponent as IconCopy } from '../svg/copy.svg';

export default createIcon(IconCopy);
